import React, { useEffect, useState } from 'react'
import { Card, Col, Form, Row } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { useParams, useNavigate } from 'react-router-dom'
import { Buffer } from 'buffer';

import { faSave, faTag } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import BreadcrumbComponent from '@component/Breadcrumb'
import ButtonComponent from '@component/Form/Button'
import TextareaComponent from '@component/Form/Textarea'
import SwitchComponent from '@component/Form/Switch'
import VerticalTimelineComponent from '@component/VerticalTimeline'

import { AclService } from '@service/acl'
import { OmbudsmanFollowupService } from '@service/ombudsman/followups'
import { OmbudsmanManifestationService } from '@service/ombudsman/manifestations'

import Swal from 'sweetalert2'


const breadcrumbItems = [
    { title: 'Dashboard', url: '/dashboard' },
    { title: 'Lista de Ocorrências', url: '/ombudsman/manifestations' },
    { title: 'Detalhes' }
]


export default function ManifestationsDeatils()
{
    const navigate = useNavigate();

    const { manifestation_id } = useParams();

    const [manifestation, setManifestation] = useState([]);

    const [followups, setFollowups] = useState([]);
    const [showFormFollowup, setShowFormFollowup] = useState(false);

    const { 
        control, 
        formState: { errors }, 
        handleSubmit, 
        register,
        setValue,
        reset
    } = useForm({ mode: 'onChange' });


    const fetchManifestation = async () => {
        Swal.fire({
            allowEscapeKey: false,
            allowOutsideClick: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
            imageUrl: '/assets/images/loading.gif',
            imageWidth: 100,
            imageHeight: 100,
            text: 'Processando, aguarde...',
            showConfirmButton: false,
            width: 300,
        });

        await OmbudsmanManifestationService.show(manifestation_id)
            .then(response => {
                setManifestation(response.data);
                if (response.data.situation === 1) { setShowFormFollowup(true); }
                fetchFollowUps();
            });
    }


    const fetchFollowUps = async () => {
        let filter = `[{ "field": "ombudsman_manifestation_id", "operator": "=", "value": ${manifestation_id} }]`;
        filter = new Buffer(filter).toString('base64');

        let order = `[{ "field": "created_at", "ordination": "desc" }]`;
        order = new Buffer(order).toString('base64');

        await OmbudsmanFollowupService.fetchbyfilter(filter, order)
            .then(response => {
                setFollowups(response.data);
                Swal.close();
            });
    }


    const onSubmit = async (data, e) => {
        e.preventDefault();

        Swal.fire({
            allowEscapeKey: false,
            allowOutsideClick: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
            imageUrl: '/assets/images/loading.gif',
            imageWidth: 100,
            imageHeight: 100,
            text: 'Processando, aguarde...',
            showConfirmButton: false,
            width: 300,
        });

        data.status = true;
        data.id_manifestation = manifestation_id;
        data.id_user = AclService.getUser().id;

        await OmbudsmanFollowupService.store(data)
            .then(() => {
                reset();
                fetchFollowUps();
                if (data.close == true) {
                    setShowFormFollowup(false);
                }
            })
            .catch(error => { 
                Swal.close();
                Swal.fire({
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    closeOnEsc: false,
                    icon: 'error',
                    text: error.response.data.message
                });
            });
    }


    useEffect(() => {
        fetchManifestation()
    }, [manifestation_id]);


    return (

        <>

            <div className='header' id='ombudsman-detail'>
                <h1 className='header-title'>Detalhes da Ocorrência - {manifestation.protocol}</h1>
                <BreadcrumbComponent breadcrumb={breadcrumbItems} />
            </div>


            
            <Row className='mb-3'>
                <Col lg={12} md={12} sm={12} xs={12}>
                    <Card>
                        <Card.Body>
                            <Row className='mb-3'>
                                <Col lg={2} md={12} sm={12} xs={12}>
                                    <div className='text-muted'>Data da Ocorrência</div>
                                    <p>{manifestation.date}</p>
                                </Col>

                                <Col lg={2} md={12} sm={12} xs={12}>
                                    <div className='text-muted'>Canal de Recebimento</div>
                                    <p>{manifestation.origin ? manifestation.origin.title : '-'}</p>
                                </Col>

                                <Col lg={2} md={12} sm={12} xs={12}>
                                    <div className='text-muted'>Tipo da Ocorrência</div>
                                    <p>{manifestation.type ? manifestation.type.title : '-'}</p>
                                </Col>

                                {/* <Col lg={2} md={12} sm={12} xs={12}>
                                    <div className='text-muted'>Categoria</div>
                                    <p>{manifestation.category ? manifestation.category.title : '-'}</p>
                                </Col> */}

                                <Col lg={2} md={12} sm={12} xs={12}>
                                    <div className='text-muted'>Área Envolvida</div>
                                    <p>{manifestation.department ? manifestation.department.title : '-'}</p>
                                </Col>

                                <Col lg={2} md={12} sm={12} xs={12}>
                                    <div className='text-muted'>Situação</div>
                                    <p>{manifestation.situation_title}</p>
                                </Col>
                            </Row>
                            
                            <Row className='mb-3'>
                                <Col lg={12} md={12} sm={12} xs={12}>
                                    <div className='text-muted'>Ocorrência</div>
                                    <p dangerouslySetInnerHTML={{ __html: manifestation.description }} />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {
                (manifestation.complainer) ? (
            
                    <Row className='mb-3'>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <Card>
                                <Card.Header>
                                    <h5 className="card-title mb-0">Dados do(a) Manifestante</h5>
                                </Card.Header>
                                <Card.Body>
                                    <Row className='mb-3'>
                                        <Col lg={4} md={12} sm={12} xs={12}>
                                            <div className='text-muted'>Nome Completo</div>
                                            <p>{AclService.getUser().position.id === 2 ? manifestation.complainer.name : 'Xxxxxxx Xxxxx Xxxxx'}</p>
                                        </Col>

                                        <Col lg={2} md={12} sm={12} xs={12}>
                                            <div className='text-muted'>CPF</div>
                                            <p>{manifestation.complainer ? AclService.getUser().position.id === 2 ? manifestation.complainer.cpf : 'XXX.XXX.XXX-XX' : '-'}</p>
                                        </Col>

                                        <Col lg={2} md={12} sm={12} xs={12}>
                                            <div className='text-muted'>Cartão SUS</div>
                                            <p>{AclService.getUser().position.id === 2 ? manifestation.complainer.card : 'XXXXXXXXXXX'}</p>
                                        </Col>

                                        <Col lg={2} md={12} sm={12} xs={12}>
                                            <div className='text-muted'>Data Nascimento</div>
                                            <p>{AclService.getUser().position.id === 2 ? manifestation.complainer.date_birth : 'XX/XX/XXXX'}</p>
                                        </Col>

                                        <Col lg={2} md={12} sm={12} xs={12}>
                                            <div className='text-muted'>Telefone/Celular</div>
                                            <p>{AclService.getUser().position.id === 2 ? manifestation.complainer.phone : '(XX) XXXXX-XXXX'}</p>
                                        </Col>

                                        <Col lg={3} md={12} sm={12} xs={12}>
                                            <div className='text-muted'>E-mail</div>
                                            <p>{AclService.getUser().position.id === 2 ? manifestation.complainer.email : 'xxxxxxx@xxxxx.xxx.xx'}</p>
                                        </Col>
                                    </Row>
                                    
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                ) : ''
            }


            {
                (showFormFollowup) ? (

                    <Form 
                        autoComplete='off'
                        id='form-followup'
                        onSubmit={handleSubmit(onSubmit)}>

                        <Row className='mb-3'>
                            <Col lg={12} md={12} sm={12} xs={12}>
                                <Card>
                                    <Card.Body>
                                        <Row className='mb-3'>
                                            <Col md={12}>
                                                <h4 className="card-title">Nova Interação</h4>
                                            </Col>
                                        </Row>

                                        <Row className='mb-3'>
                                            <Col md={12}>
                                                <TextareaComponent
                                                    control={control}
                                                    errors={errors}
                                                    name='description'
                                                    placeholder='Informe a descrição'
                                                    required={true}
                                                    register={register}
                                                    rows={4}
                                                />
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col lg={11} className='text-end'>
                                                <SwitchComponent
                                                    control={control}
                                                    errors={errors}
                                                    checked={false}
                                                    label='Encerrar?'
                                                    name='close'
                                                    required={false}
                                                    register={register}
                                                />
                                            </Col>

                                            <Col lg={1} className='text-end'>
                                                <ButtonComponent
                                                    variant='success'
                                                    icon={faSave}
                                                    id='btn-save'
                                                    title='Gravar'
                                                />
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                    </Form>

                ) : ''
            }


            <Row className='mb-3'>
                <Col lg={12} md={12} sm={12} xs={12}>
                    <Card>
                        <Card.Header>
                            <h4 className="card-title">Compartilhar Ocorrência</h4>
                            <span className='float-end'>
                               
                            </span>
                        </Card.Header>
                        <Card.Body>
                            Ocorrência não compartilhada com o departamento até o momento.                           
                        </Card.Body>
                    </Card>
                </Col>
            </Row>


            <Row className='mb-3'>
                <Col lg={12} md={12} sm={12} xs={12}>
                    <Card>
                        <Card.Header>
                            <h4 className="card-title">Histórico da Ocorrência</h4>
                            <span className='float-end'>
                               
                            </span>
                        </Card.Header>
                        <Card.Body>

                            {
                                (followups.length > 0) ?
                                    <VerticalTimelineComponent data={followups} />
                                : <p>Nenhuma interação registrada até o momento.</p>
                            }
                            
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

        </>

    )
}